<p-card class="h-full">
  <div class="flex flex-col justify-between gap-6 h-full">
    <!-- Raised Amounts Grid -->
    <div class="grid grid-cols-1 lg:grid-cols-3 gap-4">
      <!-- Total Raised in Private Sale -->
      <div class="flex flex-col gap-1">
        <span class="text-body-sm text-text-secondary">{{
          'projectInsight.raisedAmounts.totalRaisedPrivate' | translate
          }}</span>
        <span class="text-heading-lg font-bold">{{ statsService.privateRaised() | currencyFormat }} USDT</span>
        <span class="text-caption-md text-text-secondary">({{ statsService.privateContributors() }} contributors)</span>
      </div>

      <!-- Total Raised in Public Sale -->
      <div class="flex flex-col gap-1">
        <span class="text-body-sm text-text-secondary">{{
          'projectInsight.raisedAmounts.totalRaisedPublic' | translate
          }}</span>
        <span class="text-heading-lg font-bold">{{ statsService.publicRaised() | currencyFormat }} USDT</span>
        <span class="text-caption-md text-text-secondary">({{ statsService.publicContributors() }} contributors)</span>
      </div>

      <!-- Total Raised -->
      <div class="flex flex-col gap-1">
        <span class="text-body-sm text-text-secondary">{{
          'projectInsight.raisedAmounts.totalRaised' | translate
          }}</span>
        <span class="text-heading-lg font-bold">{{ statsService.totalRaised() | currencyFormat }} USDT</span>
        <span class="text-caption-md text-text-secondary">({{ statsService.totalContributors() }} contributors)</span>
      </div>
    </div>

    <!-- View Contributors Button -->
    <div>
      <p-button [label]="'projectInsight.raisedAmounts.viewContributors' | translate" icon="pi pi-users"
        class="btn-primary btn-medium" (onClick)="onViewContributorsClick()" />
    </div>
  </div>
</p-card>
